import axios, { InternalAxiosRequestConfig, AxiosResponse } from "axios";

const _axios = axios.create();

export type RequestConfigFn = (
  value: InternalAxiosRequestConfig<any>
) => InternalAxiosRequestConfig<any>;

export type ResponseConfigFn = (
  value: AxiosResponse<any, any>
) => AxiosResponse<any, any>;

export const configure = (
  baseUrl: string | undefined,
  requestConfig?: RequestConfigFn,
  responseConfig?: ResponseConfigFn
) => {
  _axios.defaults.baseURL = baseUrl;
  _axios.interceptors.request.use(requestConfig);
  _axios.interceptors.response.use(responseConfig);
};

export const getAxiosClient = () => _axios;
